export default "__VITE_ASSET__CAEZzJIe__"